const SardiniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112269)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1159 0 18.2452 0.058125 17.3913 0.169297V17.3912V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8841 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1159 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6089V22.6087H39.8307C39.9419 21.7548 40 20.8841 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z"
        fill="#D80027"
      />
      <path
        d="M29.5654 6.95703C27.9447 6.95703 26.5829 8.06555 26.1968 9.5657L29.5654 10.4352L32.9341 9.5657C32.548 8.06562 31.1862 6.95703 29.5654 6.95703Z"
        fill="black"
      />
      <path
        d="M26.0868 14.7824L30.4346 15.6519V13.8032C31.6569 13.4886 32.6189 12.5263 32.9335 11.3041L29.5651 10.4346H25.2173L26.0868 13.0432V14.7824Z"
        fill="black"
      />
      <path
        d="M32.9338 9.56543H25.2173V11.3046V13.0437H26.0868V11.3046H32.9335C33.0051 11.0267 33.0434 10.7353 33.0434 10.435C33.0434 10.1347 33.0053 9.84332 32.9338 9.56543Z"
        fill="#ACABB1"
      />
      <path
        d="M11.3047 6.95703C9.68393 6.95703 8.32213 8.06555 7.93604 9.5657L11.3047 10.4352L14.6734 9.5657C14.2873 8.06562 12.9255 6.95703 11.3047 6.95703Z"
        fill="black"
      />
      <path
        d="M7.82615 14.7824L12.174 15.6519V13.8032C13.3962 13.4886 14.3583 12.5263 14.6729 11.3041L11.3044 10.4346H6.95654L7.82607 13.0432V14.7824H7.82615Z"
        fill="black"
      />
      <path
        d="M14.6731 9.56543H6.95654V11.3046V13.0437H7.82607V11.3046H14.6728C14.7444 11.0267 14.7826 10.7353 14.7826 10.435C14.7826 10.1347 14.7447 9.84332 14.6731 9.56543Z"
        fill="#ACABB1"
      />
      <path
        d="M29.5654 24.3486C27.9447 24.3486 26.5829 25.4571 26.1968 26.9573L29.5654 27.8268L32.9341 26.9573C32.548 25.4571 31.1862 24.3486 29.5654 24.3486Z"
        fill="black"
      />
      <path
        d="M26.0868 32.175L30.4346 33.0445V31.1958C31.6569 30.8811 32.6189 29.9189 32.9335 28.6967L29.5651 27.8271H25.2173L26.0868 30.4358V32.175Z"
        fill="black"
      />
      <path
        d="M32.9338 26.957H25.2173V28.6962V30.4353H26.0868V28.6962H32.9335C33.0051 28.4183 33.0434 28.1269 33.0434 27.8266C33.0434 27.5264 33.0053 27.235 32.9338 26.957Z"
        fill="#ACABB1"
      />
      <path
        d="M11.3047 24.3486C9.68393 24.3486 8.32213 25.4571 7.93604 26.9573L11.3047 27.8268L14.6734 26.9573C14.2873 25.4571 12.9255 24.3486 11.3047 24.3486Z"
        fill="black"
      />
      <path
        d="M7.82615 32.175L12.174 33.0445V31.1958C13.3962 30.8811 14.3583 29.9189 14.6729 28.6967L11.3044 27.8271H6.95654L7.82607 30.4358V32.175H7.82615Z"
        fill="black"
      />
      <path
        d="M14.6731 26.957H6.95654V28.6962V30.4353H7.82607V28.6962H14.6728C14.7444 28.4183 14.7826 28.1269 14.7826 27.8266C14.7826 27.5264 14.7447 27.235 14.6731 26.957Z"
        fill="#ACABB1"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112269">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SardiniaSvg;
